import Vue from "vue";
import "./lib/componentLoader";
import "./plugins/axios";
import VueAwesomeSwiper from "vue-awesome-swiper";
import VueMomentJS from "vue-momentjs";
import App from "./App.vue";
import message from "./lib/message"; // 글로벌 함수가 들어있는 js 파일 import
import router from "./router";
import store from "./store";
import "./mixin";
import _moment from "moment";
import { extendMoment } from "moment-range";
import "swiper/css/swiper.css";
// import 'swiper/swiper-bundle.css'
import AOS from "aos";
import "aos/dist/aos.css";
import Jquery from "jquery";
import * as Sentry from "@sentry/vue";

// import cors from 'cors'
const moment = extendMoment(_moment);

Vue.use(VueMomentJS, moment);
Vue.use(VueAwesomeSwiper);
Vue.use(message);
Vue.use(AOS);

Vue.config.productionTip = false;

window.$EventBus = new Vue();
window.$sendMessage = message;
window.$ = Jquery;

if (process.env.VUE_APP_SENTRY_DSN) {
  Sentry.init({
    Vue,
    dsn: process.env.VUE_APP_SENTRY_DSN,
    integrations: [Sentry.replayIntegration()],
    tracesSampleRate: 0, //  Capture 100% of the transactions
    replaysSessionSampleRate: 0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}

new Vue({
  created() {
    // AOS.init({ disable: 'phone', easing: 'ease-in-out', once: true })
    AOS.init();
  },
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
